module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei5.svg";